"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchQiHuoListWithOptionTXBJ = exports.searchQiHuoListWithOption = exports.searchQiHuoListWithVariety = exports.searchQiHuoListWithMarket = exports.searchQiHuoListWithBlock = exports.getListQiHuoWithType = void 0;
var lodash_1 = __importDefault(require("lodash"));
var web_1 = __importDefault(require("../../config/web"));
var config_1 = require("./config");
var user_1 = __importDefault(require("../user"));
var qihuo_api = web_1.default.getUrl('qihuo_api');
var token = web_1.default.getUrl('qihuo_ut');
var thisuser = user_1.default.get();
/**
 * 根据类型获取期货列表
 * @param type block market option
 * @param itemlist
 * @param pageIndex
 * @param pageSize
 * @param sort
 * @param orderBy
 * @param blockname
 * @returns
 */
function getListQiHuoWithType(type, qh_code, itemlist, pageIndex, pageSize, sort, orderBy, blockname, customparams) {
    if (pageIndex === void 0) { pageIndex = 1; }
    if (pageSize === void 0) { pageSize = 10; }
    if (sort === void 0) { sort = 'desc'; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            /** 板块 */
            if (type == 'block') {
                return [2 /*return*/, searchQiHuoListWithBlock(itemlist, pageIndex, pageSize, sort, orderBy, blockname)];
            }
            /** 市场 */
            if (type == 'market') {
                return [2 /*return*/, searchQiHuoListWithMarket(qh_code, itemlist, pageIndex, pageSize, sort, orderBy, blockname)];
            }
            /** 单品 */
            if (type == 'variety') {
                return [2 /*return*/, searchQiHuoListWithVariety(qh_code, itemlist, pageIndex, pageSize, sort, orderBy, blockname)];
            }
            /** 期权 */
            if (type == 'option') {
                return [2 /*return*/, searchQiHuoListWithOption(qh_code, itemlist, pageIndex, pageSize, sort, orderBy, blockname, customparams)];
            }
            return [2 /*return*/, {
                    result: [],
                    count: 0
                }];
        });
    });
}
exports.getListQiHuoWithType = getListQiHuoWithType;
/**
 * 根据板块获取期货列表
 * @param itemlist
 * @param pageIndex
 * @param pageSize
 * @param sort
 * @param orderBy
 * @param blockname
 * @returns
 */
function searchQiHuoListWithBlock(itemlist, pageIndex, pageSize, sort, orderBy, blockname) {
    if (pageIndex === void 0) { pageIndex = 1; }
    if (pageSize === void 0) { pageSize = 10; }
    if (sort === void 0) { sort = 'desc'; }
    return __awaiter(this, void 0, void 0, function () {
        var qihuoback, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: qihuo_api + '/list/block',
                            type: 'GET',
                            dataType: 'jsonp',
                            jsonp: "callbackName",
                            // jsonpCallback: "aaa_" + blockname,
                            data: {
                                field: QiHuoListItemFields(itemlist),
                                token: token,
                                orderBy: orderBy,
                                sort: sort,
                                pageSize: pageSize,
                                pageIndex: pageIndex - 1,
                                // callbackName: "aaa_" + blockname,
                                blockName: blockname
                            }
                        })];
                case 1:
                    qihuoback = _a.sent();
                    return [2 /*return*/, {
                            result: BackListData(qihuoback, itemlist),
                            count: qihuoback === null || qihuoback === void 0 ? void 0 : qihuoback.total
                        }];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, {
                            result: [],
                            count: 0
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.searchQiHuoListWithBlock = searchQiHuoListWithBlock;
/**
 * 根据市场获取期货列表
 * @param itemlist
 * @param pageIndex
 * @param pageSize
 * @param sort
 * @param orderBy
 * @param blockname
 * @returns
 */
function searchQiHuoListWithMarket(qh_code, itemlist, pageIndex, pageSize, sort, orderBy, blockname) {
    if (pageIndex === void 0) { pageIndex = 1; }
    if (pageSize === void 0) { pageSize = 10; }
    if (sort === void 0) { sort = 'desc'; }
    return __awaiter(this, void 0, void 0, function () {
        var qihuoback, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: qihuo_api + "/list/".concat(qh_code),
                            type: 'GET',
                            dataType: 'jsonp',
                            jsonp: "callbackName",
                            // jsonpCallback: "aaa_" + blockname,
                            data: {
                                field: QiHuoListItemFields(itemlist),
                                token: token,
                                orderBy: orderBy,
                                sort: sort,
                                pageSize: pageSize,
                                pageIndex: pageIndex - 1,
                                // callbackName: "aaa_" + blockname,
                                blockName: blockname
                            }
                        })];
                case 1:
                    qihuoback = _a.sent();
                    return [2 /*return*/, {
                            result: BackListData(qihuoback, itemlist),
                            count: qihuoback === null || qihuoback === void 0 ? void 0 : qihuoback.total
                        }];
                case 2:
                    error_2 = _a.sent();
                    return [2 /*return*/, {
                            result: [],
                            count: 0
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.searchQiHuoListWithMarket = searchQiHuoListWithMarket;
/**
 * 获取单个品种期货
 * @param qh_code
 * @param itemlist
 * @param pageIndex
 * @param pageSize
 * @param sort
 * @param orderBy
 * @param blockname
 * @returns
 */
function searchQiHuoListWithVariety(qh_code, itemlist, pageIndex, pageSize, sort, orderBy, blockname) {
    if (pageIndex === void 0) { pageIndex = 1; }
    if (pageSize === void 0) { pageSize = 10; }
    if (sort === void 0) { sort = 'desc'; }
    return __awaiter(this, void 0, void 0, function () {
        var qihuoback, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: qihuo_api + "/list/variety/".concat(qh_code),
                            type: 'GET',
                            dataType: 'jsonp',
                            jsonp: "callbackName",
                            // jsonpCallback: "aaa_" + blockname,
                            data: {
                                field: QiHuoListItemFields(itemlist),
                                token: token,
                                orderBy: orderBy,
                                sort: sort,
                                pageSize: pageSize,
                                pageIndex: pageIndex - 1,
                                // callbackName: "aaa_" + blockname,
                                blockName: blockname
                            }
                        })];
                case 1:
                    qihuoback = _a.sent();
                    return [2 /*return*/, {
                            result: BackListData(qihuoback, itemlist),
                            count: qihuoback === null || qihuoback === void 0 ? void 0 : qihuoback.total
                        }];
                case 2:
                    error_3 = _a.sent();
                    return [2 /*return*/, {
                            result: [],
                            count: 0
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.searchQiHuoListWithVariety = searchQiHuoListWithVariety;
/**
 * 期权指数
 * @param qh_code
 * @param itemlist
 * @param pageIndex
 * @param pageSize
 * @param sort
 * @param orderBy
 * @param blockname
 * @returns
 */
function searchQiHuoListWithOption(qh_code, itemlist, pageIndex, pageSize, sort, orderBy, blockname, customparams) {
    if (pageIndex === void 0) { pageIndex = 1; }
    if (pageSize === void 0) { pageSize = 10; }
    if (sort === void 0) { sort = 'desc'; }
    return __awaiter(this, void 0, void 0, function () {
        var cusparams, initobj, params, qihuoback, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    cusparams = getCustomParams(customparams);
                    initobj = {
                        field: QiHuoListItemFields(itemlist),
                        token: token,
                        orderBy: orderBy,
                        sort: sort,
                        pageSize: pageSize,
                        pageIndex: pageIndex - 1,
                        // callbackName: "aaa_callback",
                        // blockName: blockname
                    };
                    params = $.extend({}, initobj, cusparams);
                    return [4 /*yield*/, $.ajax({
                            url: qihuo_api + "/list/option/".concat(qh_code),
                            type: 'GET',
                            dataType: 'jsonp',
                            jsonp: "callbackName",
                            // jsonpCallback: "callbackName",
                            data: params
                        })];
                case 1:
                    qihuoback = _a.sent();
                    return [2 /*return*/, {
                            result: BackListData(qihuoback, itemlist),
                            count: qihuoback === null || qihuoback === void 0 ? void 0 : qihuoback.total
                        }];
                case 2:
                    error_4 = _a.sent();
                    return [2 /*return*/, {
                            result: [],
                            count: 0
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.searchQiHuoListWithOption = searchQiHuoListWithOption;
/**
 * T型报价
 * @param qh_code
 * @param itemlist
 * @param pageIndex
 * @param pageSize
 * @param sort
 * @param orderBy
 * @param blockname
 * @returns
 */
function searchQiHuoListWithOptionTXBJ(qh_code, cp, date, orderBy, pageIndex, pageSize, sort) {
    if (date === void 0) { date = ""; }
    if (pageIndex === void 0) { pageIndex = 1; }
    if (pageSize === void 0) { pageSize = 10; }
    if (sort === void 0) { sort = 'desc'; }
    return __awaiter(this, void 0, void 0, function () {
        var qihuoback;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, $.ajax({
                        url: qihuo_api + "/list/variety/option/".concat(qh_code),
                        type: 'GET',
                        dataType: 'jsonp',
                        jsonp: "cb",
                        jsonpCallback: "aaa_txdata",
                        data: {
                            token: token,
                            orderBy: orderBy,
                            sort: sort,
                            cp: cp,
                            date: date,
                            pageSize: pageSize,
                            pageIndex: pageIndex - 1,
                            callbackName: "aaa_txdata",
                            blockName: 'txdata'
                        }
                    })
                    // console.log(qihuoback)
                ];
                case 1:
                    qihuoback = _a.sent();
                    // console.log(qihuoback)
                    if ((qihuoback === null || qihuoback === void 0 ? void 0 : qihuoback.list.length) > 0) {
                        return [2 /*return*/, {
                                date: qihuoback === null || qihuoback === void 0 ? void 0 : qihuoback.date,
                                result: qihuoback === null || qihuoback === void 0 ? void 0 : qihuoback.list,
                                count: qihuoback === null || qihuoback === void 0 ? void 0 : qihuoback.total
                            }];
                    }
                    return [2 /*return*/, {
                            result: [],
                            count: 0
                        }];
            }
        });
    });
}
exports.searchQiHuoListWithOptionTXBJ = searchQiHuoListWithOptionTXBJ;
/**
 * 生成调用一组行情的fields字符串
 * @param itemlist
 * @returns
 */
function QiHuoListItemFields(itemlist) {
    var fids = [];
    itemlist.forEach(function (v) {
        fids = fids.concat(config_1.ListQHItemConfig[v].fid);
    });
    var fid_list = lodash_1.default.uniq(fids).filter(function (v) { return v != ''; });
    return fid_list.join(',');
}
/**
 * 处理行情接口返回的列表数据
 * @param data
 * @param itemlist
 * @returns
 */
function BackListData(data, itemlist) {
    if (!((data === null || data === void 0 ? void 0 : data.list) instanceof Array)) {
        return [];
    }
    return data === null || data === void 0 ? void 0 : data.list.map(function (v) {
        //处理CME行情展示合规  101 102 103市场
        if (thisuser == null && (v.sc == 101 || v.sc == 102 || v.sc == 103)) {
            //除了v.name v.sc v.dm 其他属性都变成 '-'
            var v2 = {};
            for (var key in v) {
                if (key != 'name' && key != 'sc' && key != 'dm') {
                    v2[key] = '-';
                }
                else {
                    v2[key] = v[key];
                }
            }
            v = v2;
        }
        var onereturn = {};
        itemlist.forEach(function (i) {
            onereturn[i] = config_1.ListQHItemConfig[i].value(v);
        });
        return onereturn;
    });
}
/**
 * 格式化自定义参数
 * @param str
 */
function getCustomParams(str) {
    if (!str)
        return {};
    try {
        var arr = str.split(",");
        var res = arr.map(function (v) {
            var _a;
            var _b, _c;
            var key = (_b = v.split(':')) === null || _b === void 0 ? void 0 : _b[0], val = (_c = v.split(':')) === null || _c === void 0 ? void 0 : _c[1];
            return _a = {},
                _a[key] = val,
                _a;
        }).reduce(function (pre, cur) { return Object.assign(pre, cur); }, {});
        return res || {};
    }
    catch (error) {
        return {};
    }
}
